import { getProduct } from '../config'
import { useI18n } from '../i18n/LocaleContext'
import { cn } from '../lib/cn'

/**
 * "By continuing you agree to the Terms and the Privacy policy", linked.
 * Renders nothing for a product that has not configured where they live.
 */
export function LegalNotice({ className }: { className?: string }) {
  const { t, locale } = useI18n()
  const urls = getProduct().legalUrls?.(locale)
  if (!urls) return null
  const link = 'underline underline-offset-2 hover:text-gray-900'
  return (
    <p className={cn('text-[12px] leading-relaxed text-gray-500', className)}>
      {t.legal.agree}{' '}
      <a href={urls.terms} target="_blank" rel="noopener" className={link}>
        {t.legal.terms}
      </a>{' '}
      {t.legal.and}{' '}
      <a href={urls.privacy} target="_blank" rel="noopener" className={link}>
        {t.legal.privacy}
      </a>
      .
    </p>
  )
}
